import { createBundleContext } from './Bundle';

const ctx = createBundleContext('app');

export const t = (...args) => ctx.current.localizer.t(...args);
export const getResource = (...args) => ctx.current.get(...args);
export const releaseResource = (...args) => ctx.current.release(...args);

export default ctx;
